module.exports = __webpack_public_path__ + "img/fct.f0ddfdbb.svg";